module.exports = __webpack_public_path__ + "img/index-qysl9.18ca0526.png";